import EditInfoSelectedProvider from '@/components/edit-info-selected-provider/index.vue'

export default {
  components: {
    EditInfoSelectedProvider
  },
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    editing: {
      required: true,
      type: Boolean,
      default: false
    },
    rulesKyc: {
      required: true,
      type: Function
    },
    providersBasketSelected: {
      required: true,
      type: Array,
      default: []
    },
    fieldsWeight: {
      required: true,
      type: Object
    },
    configKycRules: {
      required: false,
      type: Object
    }
  },
  data () {
    return {
      dialog: false,
      pointsTotal: 0,
      qtdClassifySelected: 0,
      titleSectionDossie: '',
      kycRules: [],
      disableButtonSave: false,
      items: [
        { text: '2 Classificações', qtd: 2 },
        { text: '3 Classificações', qtd: 3 },
        { text: '4 Classificações', qtd: 4 },
        { text: '5 Classificações', qtd: 5 }
      ]
    }
  },
  watch: {
    qtdClassifySelected () {
      this.kycRules = this.generateFieldsDynamic()
    },
    kycRules: {
      deep: true,
      handler () {
        this.validationFieldsRules()
      }
    }
  },
  mounted () {
    this.dialog = true
    this.calculateTotalPoints()
    this.fillFields()
  },
  methods: {
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    calculateTotalPoints () {
      const tmpKeys = Object.keys(this.fieldsWeight)
      tmpKeys.forEach((element) => {
        if (this.fieldsWeight[element] !== undefined) {
          this.pointsTotal += this.fieldsWeight[element]
        }
      })
    },
    fillFields () {
      this.titleSectionDossie = this.configKycRules.name ? this.configKycRules.name : ''
      this.qtdClassifySelected = this.configKycRules.kycRules ? this.configKycRules.kycRules.length : 0
      this.kycRules = this.configKycRules.kycRules ? this.configKycRules.kycRules : this.generateFieldsDynamic
      if (this.editing) {
        this.kycRules.sort((a, b) => a.min - b.max)
      }
    },
    onClickMainButton (type) {
      if (type === 'save') {
        const obj = {
          name: this.titleSectionDossie,
          kycRules: this.kycRules,
          idProviderFlow: ''
        }
        this.rulesKyc(obj)
        this.closeModal()
      }
    },
    generateFieldsDynamic () {
      const fieldsRules = []
      for (let i = 0; i < this.qtdClassifySelected; i += 1) {
        if (this.configKycRules.kycRules) {
          if (this.qtdClassifySelected <= this.configKycRules.kycRules.length) {
            fieldsRules.push(
              {
                result: this.configKycRules.kycRules ? this.configKycRules.kycRules[i].result : '',
                max: this.configKycRules.kycRules ? this.configKycRules.kycRules[i].max : 0,
                min: this.configKycRules.kycRules ? this.configKycRules.kycRules[i].min : 0
              }
            )
          } else {
            fieldsRules.push(
              {
                result: '',
                max: 0,
                min: 0
              }
            )
          }
        } else {
          fieldsRules.push(
            {
              result: '',
              max: 0,
              min: 0
            }
          )
        }
      }
      return fieldsRules
    },
    validationFieldsRules () {
      for (let i = 0; i < this.kycRules.length; i += 1) {
        if (Number(this.kycRules[i].max) > this.pointsTotal) {
          this.kycRules[i].max = this.pointsTotal
        }

        // if (i > 0) {
        //   if (this.kycRules[i].min < this.kycRules[i - 1].max) {
        //     this.kycRules[i].min = Number(this.kycRules[i - 1].max) + 1
        //   }
        // }

        if (Number(this.kycRules[i].max) === 0 || this.kycRules[i].result === '') {
          this.disableButtonSave = true
          return
        }
        this.disableButtonSave = false
      }
    }
  }
}
